import React, { useState, useEffect } from "react";
import ScanIcon from "./../assets/scan_emoji.png";
import FooterLogo from "./../assets/nexus_logo.webp";
import { HEADER_COLOR, PRIMARY_COLOR } from "../constants/theme";

import { HiEye, HiEyeOff } from "react-icons/hi";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
  getAllCountry,
  getAllCurrency,
  loginUser,
} from "../services/auth/auth.service";
import { getDistributorByCode } from "../services/distributor/distributor.service";
import { getRoleByName } from "../services/role/role.service";
import { getClinicByCode } from "../services/clinic/clinic.service";
import Config from "../services/config";

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const [screenWidth, setScreenWidth] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!loginDetails?.email.trim() && !loginDetails?.password.trim()) {
      toast.error("Email & Password are required!");
      setLoading(false);

      return;
    }
    if (!loginDetails?.email.trim()) {
      toast.error("Email is required!");
      setLoading(false);

      return;
    }

    if (!loginDetails?.email.trim() && !loginDetails?.password.trim()) {
      toast.error("Password is required!");
      setLoading(false);

      return;
    }

    if (!/\S+@\S+\.\S+/.test(loginDetails?.email.trim())) {
      toast.error("Email address is invalid");
      setLoading(false);

      return;
    }

    try {
      const response = await loginUser(
        loginDetails?.email?.trim(),
        loginDetails?.password
      );

      if (response.status === 200) {
        if (response?.data?.user?.distributor_code?.length === 0) {
          toast.error("No Distributor Found");
          return;
        }
        if (response?.data?.user?.clinic_code?.length === 0) {
          toast.error("No Clinic Code Found");
          return;
        }
        sessionStorage.setItem("token", response?.data?.token);
        sessionStorage.setItem("refreshToken", response?.data?.refreshToken);
        sessionStorage.setItem("userRole", response?.data?.user?.role);
        sessionStorage.setItem("email", response?.data?.user?.email);
        sessionStorage.setItem(
          "user2FA",
          response?.data?.user?.two_fa_code_enabled
        );
        sessionStorage.setItem(
          "clinicCode",
          JSON.stringify(response?.data?.user?.clinic_code)
        );
        sessionStorage.setItem(
          "distributorCode",
          JSON.stringify(response?.data?.user?.distributor_code)
        );
        sessionStorage.setItem(
          "userLanguage",
          response?.data?.user?.language || ""
        );
        sessionStorage.setItem("userName", response?.data?.user?.name || "");
        sessionStorage.setItem(
          "userPicture",
          response?.data?.user?.picture && response?.data?.user?.picture !== "-"
            ? response?.data?.user?.picture
            : "" || ""
        );
        sessionStorage.setItem(
          "patientId",
          response?.data?.user?.patient_id
            ? response?.data?.user?.patient_id
            : ""
        );
        if (response?.data?.user.language) {
          // i18n.changeLanguage(response?.data?.user?.language);
        }
        const getDistributor = await getDistributorByCode(
          response?.data?.user?.email,
          response?.data?.user?.distributor_code[0]?.distributor_code
        );
        if (getDistributor?.status === 200) {
          if (!getDistributor?.data.data.status) {
            toast.error(
              "Distributor Blocked! Contact support to get distributor reactivated!"
            );
            return;
          }
          sessionStorage.setItem("theme", getDistributor?.data?.data?.theme);
          sessionStorage.setItem("mode", getDistributor?.data?.data?.mode);
          sessionStorage.setItem("logo", getDistributor?.data?.data?.picture);
          sessionStorage.setItem(
            "allowPartialFabrication",
            getDistributor?.data?.data?.partial_fabrication ? true : false
          );
          sessionStorage.setItem(
            "blackLogo",
            getDistributor?.data?.data?.logo_black
          );
          sessionStorage.setItem(
            "whiteLogo",
            getDistributor?.data?.data?.logo_white
          );
          sessionStorage.setItem(
            "distributorCurrency",
            getDistributor?.data?.data?.currency
          );
          sessionStorage.setItem(
            "advancePayment",
            getDistributor?.data?.data?.advance_payment || ""
          );
          sessionStorage.setItem(
            "companyCode",
            getDistributor?.data?.data?.company_code || ""
          );
        }

        const getClinicData = await getClinicByCode(
          response.data.user.email,
          response.data.user.clinic_code[0]?.clinic_code
        );
        if (getClinicData.status === 200) {
          if (!getClinicData?.data.data.status) {
            toast.error(
              "Clinic Blocked! Contact support to get clinic reactivated!"
            );
            return;
          }
          sessionStorage.setItem("clinicLogo", getClinicData?.data?.data?.logo);
          sessionStorage.setItem(
            "clinicCurrency",
            getClinicData?.data?.data?.currency
          );
        }
        const currency_reponse = await getAllCurrency(
          response?.data?.user?.email
        );
        const country_response = await getAllCountry(
          response?.data?.user?.email
        );
        if (country_response.status === 200) {
          sessionStorage.setItem(
            "allcountries",
            country_response?.data?.defaultCountries
          );
        }

        const roleFeature = await getRoleByName(
          response.data.user.email,
          response.data.user.role
        );

        if (currency_reponse.status === 200) {
          sessionStorage.setItem(
            "allcurrency",
            currency_reponse.data.defaultCurrencies
          );
        }
        if (roleFeature.data.status === 200) {
          sessionStorage.setItem(
            "feature",
            JSON.stringify(
              JSON.parse(roleFeature.data.data.features)[0].children || "[]"
            )
          );
          setLoading(false);
          toast.success(response.data.message);
          navigate("/home");

          // MY CODE
          // toast.success("Logged in!");
          // sessionStorage.setItem("email", loginDetails.email);
          // sessionStorage.setItem("token", "testToken");
        }
      } else {
        toast.error(response?.message || response?.data?.message);
        return;
      }
    } catch (error) {
      toast.error("Error logging in!");
      console.log("ERROR while logging in => ", error);
      setLoading(false);
    }
  };

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        backgroundColor: "#fae5ff",
      }}
    >
      <div
        className=""
        style={{
          position: "absolute",
          left: "50%",
          top: "0",
          height: "605px",
          width: "165vw",
          borderRadius: "50%",
          transform: "translateX(-50%) translateY(-460px)",
          backgroundColor: "rgb(203, 108, 230)",
          zIndex: "0",
        }}
      ></div>

      <div
        className="row w-100 mx-auto flex-column justify-content-between align-items-center position-relative"
        style={{
          minHeight: "100dvh",
          // backgroundColor: '#fae5ff'
        }}
      >
        <div className="col-12 p-0">
          <div
            className="d-flex flex-column justify-content-evenly align-items-center"
            style={{
              minHeight: "145px",
              paddingBottom: "18px",
              // paddingTop: '15px'
            }}
          >
            <div
              className=""
              style={{
                color: "#fae5ff",
                fontSize: "38px",
                fontWeight: "600",
              }}
            >
              SmileApp
            </div>
          </div>
        </div>

        <div className="col-12 p-0">
          <div
            className="row w-100 h-100 mx-auto flex-column align-items-center justify-content-center"
            style={{
              // minHeight: '55vh',
              gap: "35px",
            }}
          >
            <div className="col-auto p-0">
              <img
                className=""
                src={ScanIcon}
                alt="scanner"
                style={{
                  width: "55px",
                }}
              />
            </div>

            <div className="col-12 p-0">
              <form onSubmit={(e) => handleLogin(e)}>
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{
                    gap: "15px",
                  }}
                >
                  <div
                    className="position-relative d-flex align-items-center"
                    style={{
                      border: "2px solid rgb(203, 108, 230)",
                      borderRadius: "11px",
                      padding: "8px 12px",
                      backgroundColor: "rgb(255,255,255)",
                      width: "100%",
                      maxWidth: screenWidth >= 576 ? "310px" : "240px",
                      // height: '44px'
                    }}
                  >
                    <input
                      className="login-input text-start"
                      type="text"
                      placeholder="Email"
                      disabled={loading}
                      value={loginDetails.email}
                      onChange={(e) => {
                        setLoginDetails((prev) => {
                          return {
                            ...prev,
                            email: e.target.value,
                          };
                        });
                      }}
                      style={{
                        background: "none",
                        outline: "none",
                        border: "none",
                        // width: '210px',
                        width: "100%",
                        fontWeight: "400",
                        color: HEADER_COLOR,
                        letterSpacing: "0.01ch",
                        fontSize: "13.5px",
                      }}
                    />
                    {/* <div className='position-absolute w-100 h-100 d-flex align-items-center justify-content-center' style={{
											top: '0',
											left: '0',
											borderRadius: '12px',
											color: 'rgb(203, 108, 230)',
										}}>
											Email
										</div> */}
                  </div>
                  <div
                    className="position-relative d-flex align-items-center"
                    style={{
                      border: "2px solid rgb(203, 108, 230)",
                      borderRadius: "11px",
                      padding: "8px 12px",
                      backgroundColor: "rgb(255,255,255)",
                      // height: '44px',
                      width: "100%",
                      maxWidth: screenWidth >= 576 ? "310px" : "240px",
                    }}
                  >
                    <input
                      className="login-input text-start"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={loginDetails?.password}
                      disabled={loading}
                      style={{
                        background: "none",
                        outline: "none",
                        border: "none",
                        // width: '210px',
                        width: "100%",
                        fontWeight: "400",
                        color: HEADER_COLOR,
                        letterSpacing: "0.01ch",
                        paddingInlineEnd: "22px",
                        fontSize: "13.5px",
                        // paddingInlineEnd: '30px'
                      }}
                      onChange={(e) =>
                        setLoginDetails((prev) => {
                          return { ...prev, password: e.target.value };
                        })
                      }
                    />
                    {/* <div className='position-absolute w-100 h-100 d-flex align-items-center justify-content-center' style={{
											top: '0',
											left: '0',
											borderRadius: '12px',
											color: 'rgb(203, 108, 230)',
											fontWeight: '500'
										}}>
											Password
										</div> */}

                    <div
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        right: "9px",
                        top: "0",
                        height: "100%",
                      }}
                    >
                      {loginDetails?.password !== "" &&
                        (!showPassword ? (
                          <HiEye
                            style={{
                              height: "20px",
                              width: "20px",
                              color: PRIMARY_COLOR,
                            }}
                            onClick={() => setShowPassword(true)}
                          />
                        ) : (
                          <HiEyeOff
                            style={{
                              height: "20px",
                              width: "20px",
                              color: PRIMARY_COLOR,
                            }}
                            onClick={() => setShowPassword(false)}
                          />
                        ))}
                    </div>
                  </div>
                  <button
                    className="btn"
                    disabled={loading}
                    style={{
                      backgroundColor: "rgb(203, 108, 230)",
                      color: "#fae5ff",
                      // width: '237px',
                      borderRadius: "11px",
                      // height: '44px',
                      width: "100%",
                      maxWidth: screenWidth >= 576 ? "310px" : "240px",
                      fontSize: "13.5px",
                      padding: "9px 12px",
                    }}
                  >
                    Login
                  </button>
                </div>
              </form>

              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  marginTop: "8px",
                }}
              >
                {!loading ? (
                  <Link
                    to="/forgot-password"
                    className="btn text-center"
                    style={{
                      display: "block",
                      fontSize: "13.5px",
                      padding: "0",
                      // marginTop: '4px',
                      flex: "0 0 auto",
                      width: "auto",
                      background: "none",
                      border: "none",
                      color: HEADER_COLOR,
                      textDecoration: "underline",
                    }}
                  >
                    Forgot Password?
                  </Link>
                ) : (
                  <Link
                    // to="/forgot-password"
                    className="btn text-center"
                    style={{
                      display: "block",
                      fontSize: "13.5px",
                      padding: "0",
                      // marginTop: '4px',
                      flex: "0 0 auto",
                      width: "auto",
                      background: "none",
                      border: "none",
                      color: HEADER_COLOR,
                      textDecoration: "underline",
                    }}
                  >
                    Forgot Password?
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-12 p-0"
          style={
            {
              // marginTop: '35px'
            }
          }
        >
          <div
            className="row w-100 h-100 mx-auto align-items-center justify-content-center"
            style={{
              // minHeight: '15vh',
              padding: "0 0 20px 0",
            }}
          >
            <div className="d-flex flex-column w-100 justify-content-center align-items-center m-0 p-0">
              <div>
                <p
                  style={{
                    fontSize: "12px",
                    color: PRIMARY_COLOR,
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  Powered By:{" "}
                </p>
              </div>

              <div>
                <img
                  className=""
                  src={FooterLogo}
                  alt="footer logo"
                  style={{
                    width: "85px",
                  }}
                />
              </div>

              <div>
                <p
                  style={{
                    fontSize: "12px",
                    color: PRIMARY_COLOR,
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  {Config.appEnv} - {Config.appVersion}{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
